<template>
    <div class="pcYhgl">
<!--        <div style="text-align: right;">
            <el-button type="primary" @click="addClk">新增</el-button>
        </div>-->
      <div class="search">
        <el-select v-model="zt" :popper-append-to-body="false" filterable placeholder="状态" clearable style="width: 12%;">
          <el-option value="0" label="已禁用">已禁用</el-option>
          <el-option value="1" label="启用中">启用中</el-option>
          <el-option value="2" label="已注销">已注销</el-option>
        </el-select>
        <el-select v-model="yhlx" :popper-append-to-body="false" filterable placeholder="用户类型"	clearable style="width: 170px;margin: 0 0 10px 10px;">
          <el-option v-for="item in yhlxList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
        </el-select>
        <el-input v-model="yhmc" placeholder="姓名、手机号" clearable style="width: 200px;margin: 0px 10px 10px 10px;"></el-input>
        <el-button @click="findYonghuList" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      </div>
      <div slot="content" style="height: 100%">
        <el-table :data="tableData" style="width: 100%;" height="calc(100% - 10px)" v-loading="loading" border>
            <el-table-column type="index" label="序号" width="70"></el-table-column>
            <el-table-column prop="yhlxmc" label="用户类型"></el-table-column>
            <el-table-column prop="yhmc" label="姓名"></el-table-column>
            <el-table-column prop="dlmc" label="登录名"></el-table-column>
            <el-table-column prop="sjh" label="手机号"></el-table-column>
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
<!--                  <span v-if="scope.row.zt == 1">已启用</span>
                  <span v-if="scope.row.zt == 0">已停用</span>
                  <span v-if="scope.row.zt == 2">已注销</span>-->
                  <el-tag size="mini" v-if="scope.row.zt==1">已启用</el-tag>
                  <el-tag size="mini" v-if="scope.row.zt==0" type="danger">已停用</el-tag>
                  <el-tag size="mini" v-if="scope.row.zt==2" type="info">已注销</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <el-button type="text" size="small" style="color: #409EFF;" @click="xgmmClk(scope.row.id)">设置登录密码</el-button>
<!--                    <el-button type="text" size="small" style="color: #409EFF;" v-if="scope.row.zt === 0" @click="redactClk(scope.row.id,scope.row.yhmc,scope.row.sjh)">编辑</el-button>-->
                    <el-button type="text" size="small" style="color: #409EFF;" v-if="scope.row.yhlx!=='101001' && scope.row.zt === 1" @click="editZtClk(scope.row.id,0)">停用</el-button>
                    <el-button type="text" size="small" style="color: #409EFF;" v-if="scope.row.yhlx!=='101001' && scope.row.zt === 0" @click="editZtClk(scope.row.id,1)">启用</el-button>
<!--                    <el-button type="text" size="small" style="color: #409EFF;" v-if="scope.row.zt === 0" @click="delClk(scope.row.id)">删除</el-button>-->
                </template>
            </el-table-column>
        </el-table>
      </div>
        <!-- 申请/编辑项目 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogStatus" width="500px" :before-close="handleClose"
            :close-on-click-modal="false">
            <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="80px">
                <el-form-item label="姓名" prop="yhmc">
                    <el-input v-model="ruleForm.yhmc"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="sjh">
                    <el-input v-model="ruleForm.sjh"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="saveClk('ruleForm')" :loading="submitLoading">确 定</el-button>
            </span>
        </el-dialog>
      <!-- 修改密码 -->
      <el-dialog title="设置密码" :close-on-click-modal="false" :visible.sync="dialogEditPwdForm">
        <div class="newpassword" style="margin-bottom: 10px">
          <label style="margin-left: 28px">新密码:</label>
          <el-input style="display: inline-block;width: 80%" v-model="newpassword" type="password" show-password :placeholder="pwdTipe"></el-input>
        </div>
        <div class="repassword">
          <label>新密码确认:</label>
          <el-input style="display: inline-block;width: 80%" v-model="repassword" type="password" show-password :placeholder="'新'+pwdTipe"></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogEditPwdForm = false">取 消</el-button>
          <el-button type="primary" @click="eidtPassword()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'pcYhgl',
  data() {
    return {
      zt: '',//状态
      yhlx: '',//用户类型
      yhlxList: [],//用户类型列表
      yhmc: '',//姓名
      tableData: [],
      loading: false,
      dialogTitle: '新增',
      dialogStatus: false,
      submitLoading: false,
      id:'',
      dialogEditPwdForm: false,
      newpassword: '',//新密码
      repassword: '',//确认密码
      passwordRule: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?])[\S\s]{8,16}$',
      pwdTipe: '密码应由8到16位且包含大小写字母、特殊符号和数字组成',
      ruleForm: {
        yhmc: '',
        sjh: '',
      },
      rules: {
        yhmc: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.sltData();
    this.getConfigInfo();
    this.findYonghuList();
  },
  methods: {
    // 下拉列表数据
    sltData() {
      var _this = this;
      // 城市列表
      _this.$post("sys/findSysDictList", { dictType: "G", dictGroup: "101" }).then(rep => {
        if (rep.code == 1) {
          _this.yhlxList = rep.result.dictionaryList;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    //获取系统配置信息
    getConfigInfo(){
      this.$post('sys/findSysConfigByConfigKey',{configKey: "password_rule"}).then((arg) => {
        this.passwordRule = arg.result.sysConfig.configValue;
        this.pwdTipe = arg.result.sysConfig.configDes;
      })
    },
    findYonghuList() {
      var _this = this;
      var params = {
        zt:this.zt,
        yhmc:this.yhmc,
        yhlx:this.yhlx,
      }
      _this.$post("user/yonghuList",params).then(rep =>{
        _this.tableData = rep.result.yonghuList;
      })
    },
    // 新增
    addClk() {
      this.id = '';
      this.ruleForm = {
        yhmc: '',
        sjh: '',
      };
      this.dialogTitle = '新增';
      this.dialogStatus = true;
    },
    // 编辑
    redactClk(id,yhmc,sjh) {
      this.id = id;
      this.ruleForm.yhmc = yhmc;
      this.ruleForm.sjh = sjh;
      this.dialogTitle = '编辑';
      this.dialogStatus = true;
    },
    // 新增/编辑保存数据
    saveClk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            id: this.id,
            yhlx: this.activeName,
            xxId: this.xxId,
            yhmc: this.ruleForm.yhmc,
            sjh: this.ruleForm.sjh
          }
          this.$post("user/yonghuSave",obj,'json').then(rep =>{
            if(rep.code == '1'){
              this.$message({
                type: "success",
                message: '保存成功'
              });
              this.dialogStatus = false;
              this.findYonghuList();
            }else{
              this.$message({
                type: "error",
                message: rep.msg
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 弹窗关闭前
    handleClose() {
      this.id = '';
      this.ruleForm = {
        yhmc: '',
        sjh: '',
      };
      this.dialogStatus = false;
      this.$refs['ruleForm'].resetFields();
    },
    // 修改密码
    xgmmClk(id) {
      this.id = id;
      this.newpassword = '';
      this.repassword = '';
      this.dialogEditPwdForm = true;
    },
    //修改密码
    eidtPassword(){
      if(this.newpassword==""){
        this.$message({
          type: "error",
          message: "请输入新密码"
        });
        return;
      }else{
        var checkPwd = this.checkPwd(this.newpassword,this.passwordRule);
        if(!checkPwd){
          this.$message({
            type: "error",
            message: "新"+this.pwdTipe
          });
          return;
        }
      }
      if(this.repassword==""){
        this.$message({
          type: "error",
          message: "请输入确认密码"
        });
        return;
      }else{
        var checkPwd = this.checkPwd(this.repassword,this.passwordRule);
        if(!checkPwd){
          this.$message({
            type: "error",
            message: "确认"+this.pwdTipe
          });
          return;
        }else{
          if(this.newpassword!=this.repassword){
            this.$message({
              type: "error",
              message: "两次密码不一致"
            });
            return;
          }
        }
      }
      var _this = this;
      var params = {
        "userId":this.id,
        "newPassword":this.newpassword
      };
      _this.$post("user/eidtPassword",params).then(function(response) {
        if (response.result == "1") {
          _this.$message({
            type: "success",
            message: response.message
          });
          _this.dialogEditPwdForm = false;
          _this.findYonghuList();
        } else {
          _this.$message({
            type: "error",
            message: response.message
          });
        }
      }).catch(function(error) {
        // console.error(err);
      });
    },

    // 启用/停用
    editZtClk(id,zt) {
      var title = zt===1?"是否确认启用":"是否确认停用";
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("user/yonghuZtEdit",{id:id,zt:zt}).then(rep =>{
          if(rep.code == '1'){
            this.$message.success('操作成功');
            this.findYonghuList();
          }else{
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
            type: 'info',
            message: '已取消'
        });
      });
    },
    // 删除
    delClk(id) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("user/yonghuDel",{id:id}).then(rep =>{
          if(rep.code == '1'){
            this.$message.success('删除成功');
            this.findYonghuList();
          }else{
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  }
}
</script>

<style>
.pcYhgl{
  height: calc(100% - 50px);
}
</style>